export const heroQuick = [
  { label: "本周新增实锤", num: "12", unit: "起" },
  { label: "存疑跟进中", num: "6", unit: "起" },
  { label: "已反转辟谣", num: "3", unit: "起" },
];

export const heroSeals = [
  { text: "截图石锤", icon: "ri-image-2-line" },
  { text: "录音视频", icon: "ri-mic-line" },
  { text: "时间线梳理", icon: "ri-timeline-view" },
  { text: "细节对比", icon: "ri-focus-3-line" },
];

export const topicWall = [
  { tag: "#塌房翻车", desc: "人设崩了的当晚", count: 214 },
  { tag: "#录音曝光", desc: "私下对话被放出", count: 168 },
  { tag: "#税事风云", desc: "数字对不上的时候", count: 141 },
  { tag: "#学历造假", desc: "简历包装被扒", count: 127 },
  { tag: "#代言纠纷", desc: "品牌连夜解约", count: 98 },
  { tag: "#舆论反转", desc: "事件出现第二季", count: 87 },
  { tag: "#饭圈争端", desc: "控评与反噬", count: 76 },
  { tag: "#综艺剧本", desc: "剪辑背后的线", count: 63 },
];

export const cases = [
  {
    title: "头部主播「佣金比例」口径前后矛盾",
    cat: "#塌房翻车",
    date: "09-02",
    status: "实锤",
    heat: 982,
    tags: ["截图", "录音", "转账记录"],
    summary: "公开直播称只抽 8%，合作方放出的合同与打款流水显示实际累计抽成 32%，两处口径对不上。",
  },
  {
    title: "顶流偶像疑似「舞台垫音」原声流出",
    cat: "#录音曝光",
    date: "08-30",
    status: "存疑",
    heat: 861,
    tags: ["视频", "音频"],
    summary: "一段未注明来源的现场收音在网络流转，制作方暂未回应，待官方音源比对后再下结论。",
  },
  {
    title: "知识博主「海外名校学历」被指夸大",
    cat: "#学历造假",
    date: "08-28",
    status: "实锤",
    heat: 790,
    tags: ["原帖", "截图"],
    summary: "其公开简历与学校官方在读名单存在出入，本人已更新个人主页介绍并致歉。",
  },
  {
    title: "某综艺「票数反转」剪辑争议复盘",
    cat: "#综艺剧本",
    date: "08-24",
    status: "反转",
    heat: 688,
    tags: ["视频", "时间线"],
    summary: "逐帧对比同一表演的播出版与练习版，票数画面被重新排序，多方已回应系后期失误。",
  },
  {
    title: "品牌方连夜解约「问题代言人」",
    cat: "#代言纠纷",
    date: "08-20",
    status: "实锤",
    heat: 631,
    tags: ["原帖", "公告"],
    summary: "代言人相关言论与视频被逐一核实后，品牌先后删除合作物料并发布解约声明。",
  },
  {
    title: "「隔空喊话」事件二次反转复盘",
    cat: "#舆论反转",
    date: "08-16",
    status: "进展",
    heat: 570,
    tags: ["截图", "录音"],
    summary: "首轮信息源已被证伪，新放出的完整聊天记录让事件走向出现第二季，持续跟进中。",
  },
];

export const timelineSpot = {
  kicker: "时间线梳理 · 本周焦点",
  title: "一起「代言危机」从发酵到解约的全过程",
  cover: "https://readdy.ai/api/search-image?query=A%20warm%20desk%20of%20an%20investigative%20dossier%20with%20printed%20documents%20paper%20clips%20red%20stamp%20seals%20and%20a%20chronology%20timeline%20sketch%20on%20cream%20paper%2C%20forensic%20documentation%20style%2C%20muted%20beige%20with%20subtle%20crimson%20and%20amber%20accents%2C%20editorial%20still%20life%2C%20soft%20natural%20window%20light&width=1200&height=760&seq=timeline-cover-01&orientation=landscape",
  desc: "我们把整件事按时间拆成七个节点，每一个节点都对应可查的截图、录音或原帖存档，供你自行比对，而不是听我们下结论。",
  events: [
    { time: "08-02 20:14", title: "首个帖子出现", tag: "原帖", text: "某匿名账号放出 3 张合作聊天截图，称「报价与宣发稿里的数字不一样」。" },
    { time: "08-03 09:30", title: "二次发酵", tag: "截图", text: "相关截图被多个大号转发，讨论从「价格争议」扩散到「口径不一致」。" },
    { time: "08-05 11:02", title: "当事人回应", tag: "原帖", text: "当事人发文解释称「系旧协议」，未更新后续，质疑声未平息。" },
    { time: "08-07 15:40", title: "完整录音流出", tag: "录音", text: "一段近 4 分钟的对话录音被放出，与早前说法出现明显出入。" },
    { time: "08-10 18:26", title: "品牌方关注", tag: "进展", text: "合作品牌账号删除相关合作物料，市场部声明「正在核实」。" },
    { time: "08-12 12:00", title: "连夜解约", tag: "公告", text: "品牌发布解约声明，双方合作终止，事件告一段落。" },
    { time: "08-13 08:00", title: "二手信息核查", tag: "存疑", text: "部分搬运号开始二次加工时间线，已有 2 处细节被证伪，需注意分辨。" },
  ],
};

export const hotRank = [
  { rank: 1, title: "「佣金 8% vs 32%」口径之争", heat: 982, trend: "up", status: "实锤" },
  { rank: 2, title: "舞台垫音原声流出引战", heat: 861, trend: "up", status: "存疑" },
  { rank: 3, title: "海外名校学历被指夸大", heat: 790, trend: "down", status: "实锤" },
  { rank: 4, title: "综艺票数剪辑争议", heat: 688, trend: "up", status: "反转" },
  { rank: 5, title: "代言人连夜解约事件", heat: 631, trend: "down", status: "实锤" },
  { rank: 6, title: "隔空喊话二次反转", heat: 570, trend: "new", status: "进展" },
  { rank: 7, title: "素人维权长文获转", heat: 498, trend: "down", status: "存疑" },
  { rank: 8, title: "「打假博主」被反打脸", heat: 442, trend: "up", status: "辟谣" },
];

export const contrastRows = [
  {
    issue: "关于佣金抽成比例",
    claim: "本人直播原话：只抽合作方 8%，明码标价。",
    claimType: "说法",
    fact: "合同与打款流水：累计抽成 32%，含多笔私下「渠道费」。",
    factType: "实锤",
    verdict: "打脸",
  },
  {
    issue: "关于学历与就读状态",
    claim: "简介自称「某名校硕士毕业」。",
    claimType: "说法",
    fact: "校方在读名单与其公开年份不符，已自行修改介绍。",
    factType: "实锤",
    verdict: "翻车",
  },
  {
    issue: "关于「只在舞台上真唱」",
    claim: "节目组声明：全程真唱、无任何垫音。",
    claimType: "说法",
    fact: "现场收音与混音母带波形高度重合，待官方复核。",
    factType: "存疑",
    verdict: "存疑",
  },
  {
    issue: "关于「从未营销人设」",
    claim: "团队回应：从无剧本、无刻意营销。",
    claimType: "说法",
    fact: "旧群聊提到「按脚本走情绪」，真实性待完整上下文确认。",
    factType: "存疑",
    verdict: "存疑",
  },
];

export const archiveImgs = [
  { src: "https://readdy.ai/api/search-image?query=Top-down%20flat%20lay%20of%20printed%20chat%20message%20pages%20and%20crimson%20bank%20transfer%20receipts%20pinned%20on%20warm%20cream%20paper%20with%20string%20and%20paper%20clips%2C%20forensic%20evidence%20dossier%20style%2C%20soft%20natural%20light%2C%20muted%20beige%20with%20red%20seal%20accents%2C%20editorial%20documentation%20photography&width=720&height=900&seq=arch-01&orientation=portrait", type: "转账记录", source: "归档 · A-0147" },
  { src: "https://readdy.ai/api/search-image?query=Printed%20signed%20contract%20pages%20with%20highlighted%20clauses%20and%20fingerprints%20laid%20on%20an%20aged%20kraft%20folder%2C%20warm%20amber%20desk%20lamp%2C%20forensic%20audit%20style%2C%20cream%20and%20dark%20brown%20tones%20with%20faint%20red%20seal%2C%20editorial%20still%20life%2C%20high%20detail&width=720&height=900&seq=arch-02&orientation=portrait", type: "合同截图", source: "归档 · A-0151" },
  { src: "https://readdy.ai/api/search-image?query=Vintage%20tape%20recorder%20and%20condenser%20microphone%20next%20to%20handwritten%20case%20notes%20and%20amber%20sticky%20labels%20on%20warm%20paper%20background%2C%20documentary%20evidence%20photography%2C%20warm%20amber%20and%20charcoal%20tones%2C%20shallow%20depth%20of%20field%2C%20editorial%20style&width=720&height=900&seq=arch-03&orientation=portrait", type: "录音来源", source: "归档 · B-0203" },
  { src: "https://readdy.ai/api/search-image?query=A%20phone%20lying%20face%20down%20beside%20printed%20social%20media%20post%20screenshots%20pinned%20to%20a%20corkboard%20with%20amber%20push%20pins%2C%20investigative%20flat%20lay%2C%20warm%20beige%20palette%20with%20muted%20red%20annotations%2C%20editorial%20photography%2C%20soft%20evening%20light&width=720&height=900&seq=arch-04&orientation=portrait", type: "微博原帖", source: "归档 · A-0160" },
  { src: "https://readdy.ai/api/search-image?query=Handwritten%20timeline%20notebook%20pages%20with%20red%20circled%20dates%20and%20washi%20tape%2C%20fountain%20pen%20ink%20on%20cream%20paper%2C%20chronological%20case%20mapping%2C%20warm%20documentary%20editorial%20style%2C%20soft%20shadow%2C%20high%20detail&width=720&height=900&seq=arch-05&orientation=portrait", type: "时间线手账", source: "整理 · C-0031" },
  { src: "https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20two%20printed%20comparison%20documents%20with%20circled%20differences%20and%20red%20and%20gold%20annotations%20on%20warm%20cream%20desk%2C%20forensic%20detail%20editorial%20photography%2C%20muted%20tones%2C%20soft%20lighting&width=720&height=900&seq=arch-06&orientation=portrait", type: "细节对比", source: "整理 · C-0042" },
  { src: "https://readdy.ai/api/search-image?query=Printed%20bank%20statements%20and%20invoices%20with%20highlighted%20amounts%20arranged%20on%20a%20warm%20beige%20background%20with%20small%20paper%20clips%20and%20a%20ruler%2C%20financial%20audit%20documentation%20style%2C%20warm%20muted%20editorial%20photography&width=720&height=900&seq=arch-07&orientation=portrait", type: "发票流水", source: "归档 · A-0188" },
  { src: "https://readdy.ai/api/search-image?query=A%20stack%20of%20printed%20group%20chat%20pages%20with%20red%20arrow%20markings%20and%20crossed%20out%20dates%20on%20warm%20paper%2C%20case%20review%20desk%20scene%2C%20forensic%20documentation%20aesthetic%2C%20cream%20and%20dark%20ink%20tones%20with%20amber%20highlights%2C%20editorial%20still%20life&width=720&height=900&seq=arch-08&orientation=portrait", type: "群聊存档", source: "归档 · B-0211" },
];

export const faqs = [
  {
    q: "「实锤 / 存疑 / 辟谣」这几个标签是怎么定的？",
    a: "只有当截图、录音、视频或官方公告等可核验信源能互相印证时，我们才标「实锤」；只有单一来源、尚待官方或当事人回应的标「存疑」；后续被证伪的会统一归入「辟谣 / 反转」。每个结论都尽量附上来源说明。",
  },
  {
    q: "同一张截图为什么会有两种解读？",
    a: "截图只截取局部，语境常常被切掉。我们会把「前文后文、时间、对象」尽量补全，也会在细节对比里把不同版本并排，避免单看一张图就下判断。",
  },
  {
    q: "录音就一定等于真相吗？",
    a: "不一定。录音可能被剪辑、转述或脱离上下文。我们会标注录音时长、来源是否可追溯，以及是否存在二次加工痕迹，供你自己判断。",
  },
  {
    q: "热度榜的数字是怎么来的？",
    a: "综合讨论量、转发量与检索趋势估算，只作参考，不代表事件本身的真实性。热度高只说明「被聊得多」，不等于「被证明」。",
  },
  {
    q: "看到「反转」时我该信哪边？",
    a: "先看晚放出的完整上下文能否覆盖早前遗漏，再看官方与当事人是否有明确回应。与其选边站，不如把两版都读完再做判断。",
  },
];

export const tagsCloud = ["实锤证据", "截图石锤", "录音视频", "时间线梳理", "细节对比", "原帖存档", "辟谣反转", "热度榜"];